import { managementMenusMap } from '../_data/menus'


import { useUrl } from '@/hooks/routes';
export function useGetPagePermissionName() {
  const url = useUrl()

  const getPagePermissionName = () => {
    const pageList = Object.values(managementMenusMap)
    return pageList.find((v) => url.pathname.includes(v.href))?.permission
  }

  return { getPagePermissionName }
}
